import Table from '@/components/table/components/Table.tsx';
import participantsApi from '@/features/dashboard/participants/api/participantsApi.ts';
import { participantsApiQueryKeys } from '@/features/dashboard/participants/api/participantsApi.queryKeys.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { useNavigate } from '@tanstack/react-router';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import { participantsRoute } from '@/features/dashboard/participants/routes/participantsRoute.ts';

const ParticipantsTable = () => {
  const navigate = useNavigate();
  const search = participantsRoute.useSearch();

  const rowContextMenuItems: RowContextMenuItemParams<RowWithId>[] = [
    {
      label: 'Szczegóły',
      action: (row) =>
        navigate({
          to: '/app/participants/$participantId/info',
          params: { participantId: row.id },
        }),
    },
  ];

  return (
    <Table
      listSearch={search}
      queryKey={participantsApiQueryKeys.all()}
      fetchData={participantsApi.getParticipants}
      fetchTableDef={participantsApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
      bulkActions={[]}
      tagTargetType={TaggableType.PARTICIPANT}
      title="Uczestnicy"
    />
  );
};

export default ParticipantsTable;
